
import { ShipPiece } from './ShipPiece.js'
import type { ShipType, Direction } from '@fleetduel/shared'
import { ALL_SHIP_TYPES } from '@fleetduel/shared'

interface ShipDockProps {
  placedShips: Set<ShipType>
  selectedShip: ShipType | null
  direction: Direction
  onSelectShip: (type: ShipType) => void
  onToggleDirection: () => void
  onConfirm: () => void
  canConfirm: boolean
  /** Stack the ship pieces vertically (used by the wide left-column layout) */
  vertical?: boolean
  /** Dense layout for small screens: less padding, no redundant title */
  compact?: boolean
}

export function ShipDock({
  placedShips,
  selectedShip,
  direction,
  onSelectShip,
  onToggleDirection,
  onConfirm,
  canConfirm,
  vertical = false,
  compact = false,
}: ShipDockProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: compact ? 8 : 12,
      padding: compact ? 4 : 16,
    }}>
      {/* The screen heading already says "Place Your Fleet" — skip on compact */}
      {!compact && (
        <div style={{ fontSize: 14, color: '#b0bec5', fontWeight: 600 }}>
          Place Your Ships
        </div>
      )}

      {/* Ship pieces */}
      <div style={{ display: 'flex', flexDirection: vertical ? 'column' : 'row', gap: compact ? 4 : 8, alignItems: compact ? 'flex-end' : undefined }}>
        {ALL_SHIP_TYPES.map(type => (
          <ShipPiece
            key={type}
            shipType={type}
            isPlaced={placedShips.has(type)}
            isSelected={selectedShip === type}
            onClick={() => onSelectShip(type)}
            compact={compact}
          />
        ))}
      </div>

      {/* Direction toggle — compact reserves the slot so picking up a ship
          never shifts the confirm button under the user's finger */}
      {(selectedShip || compact) && (
        <button
          onClick={onToggleDirection}
          style={{
            padding: compact ? '6px 14px' : '8px 16px',
            fontSize: 12,
            border: '1px solid #37474f',
            borderRadius: 4,
            backgroundColor: '#263238',
            color: '#b0bec5',
            cursor: 'pointer',
            visibility: selectedShip ? 'visible' : 'hidden',
          }}
        >
          Direction: {direction === 'horizontal' ? 'Horizontal' : 'Vertical'}
        </button>
      )}

      {/* Confirm button */}
      <button
        onClick={onConfirm}
        disabled={!canConfirm}
        style={{
          padding: compact ? '10px 28px' : '12px 32px',
          fontSize: compact ? 14 : 16,
          fontWeight: 700,
          border: 'none',
          borderRadius: 8,
          backgroundColor: canConfirm ? '#2e7d32' : '#1a2a3a',
          color: canConfirm ? '#fff' : '#546e7a',
          cursor: canConfirm ? 'pointer' : 'not-allowed',
        }}
      >
        Confirm Placement
      </button>
    </div>
  )
}
